import { CLOSE_MODAL, COMPLETE_TROLLEY_REQUEST, FETCH_RECOMMENDATIONS_COMPLETED, UPDATE_TROLLEY_SUCCEEDED } from '../actions';
import { calculateTotal } from '../helpers';
import { onRecommendationsLoaded, onAddToTrolleyModalShut } from '../helpers/tracking';
/**
 * [callbacksMiddleware description]
 * @method callbacksMiddleware
 * @param  {[type]}            props [description]
 * @return {[type]}                  [description]
 */

export var callbacksMiddleware = function callbacksMiddleware() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (store) {
    return function (next) {
      return function (action) {
        switch (action.type) {
          /**
           * Callback for CLOSE_MODAL
           */
          case CLOSE_MODAL:
            {
              if (props.onModalClose) {
                onAddToTrolleyModalShut();
                props.onModalClose();
              }

              break;
            }

          /**
           * Callback for COMPLETE_TROLLEY_REQUEST
           */

          case COMPLETE_TROLLEY_REQUEST:
            {
              if (props.onSuccessfulRequest) {
                var total = calculateTotal(action.payload);
                props.onSuccessfulRequest({
                  total: total,
                  productMap: action.payload
                });
              }

              break;
            }

          /**
           * Callback for FETCH_RECOMMENDATIONS_COMPLETED
           */

          case FETCH_RECOMMENDATIONS_COMPLETED:
            {
              if (store.getState().trolleyModal.pendingRequestCount === 0) {
                onRecommendationsLoaded(store.getState().trolleyModal);
              }
              /* This should be merged into the code above at some point soon */


              if (props.onFetchRecommendationsCompleted) {
                props.onFetchRecommendationsCompleted(store.getState().trolleyModal);
              }

              break;
            }

          case UPDATE_TROLLEY_SUCCEEDED:
            {
              break;
            }

          default:
            break;
        }

        return next(action);
      };
    };
  };
};
export default callbacksMiddleware;